import {IPortalseite, ISchueler_testsAPI, TFach} from "../Interfaces";
import Utilities from "./../Utilities";
import Rueckmeldung from "./Rueckmeldung";
import Tooltip, {TOOLTIP_INHALTE} from '../Tooltip';

export default class RueckmeldungKsSchuelerebene extends Rueckmeldung implements IPortalseite {
    private faecherArr: TFach[];

    override async onSeiteLoad(): Promise<boolean> {


        await super.onSeiteLoad();
        await this.filterAnwenden();

        if (this.rmFilter.fach === 'alle')
            this.faecherArr = ['ma', 'de', 'en', 'fr'];
        else
            this.faecherArr = [this.rmFilter.fach];

        //Spaltenköpfe einbinden und Sortierung initialisieren
        if (this.domaenenInGruppe.length === 0)
            return true;

        // Dokument mit Kompetenzstufenbeschreibungen verlinken
        if (this.sessionvariablen.schule.land !== 'nw') {
            document.querySelector(`div.ks-beschreibungen-container`).innerHTML = `
        <p>Hier finden Sie die Kompetenzstufenbeschreibungen zum Herunterladen:</p>
        <ul>
            ${this.rmFilter.fach !== 'ma' ? `
            ${this.domaenenInGruppe.map(domaene => `
            <li>
                <a href="/materialien/vera8/ks-beschreibungen/VERA8_Kompetenzstufenbeschreibung_${Utilities.printFachLang(this.rmFilter.fach)}_${domaene.bezeichnung}.pdf" target="kompetenzstufenbeschreibung">
                    <svg role="graphics-symbol">
                        <use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#file-pdf"/>
                    </svg>
                KS-Beschreibungen: ${Utilities.printFachLang(this.rmFilter.fach)} ${domaene.bezeichnung}
                </a>
            </li>`).join('')}
            ` : `
             <li>
                <a href="/materialien/vera8/ks-beschreibungen/VERA8_Kompetenzstufenbeschreibung_Mathematik.pdf" target="kompetenzstufenbeschreibung">
                    <svg role="graphics-symbol">
                        <use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#file-pdf"/>
                    </svg>
                KS-Beschreibungen: Mathematik
                </a>
            </li>
            `}
            
        </ul>
        `;
        } else {
            document.querySelector(`div.ks-beschreibungen-container`).innerHTML = `
        <p>Sie finden ausführliche Kompetenzstufenbeschreibungen auf den Seiten des QUA-LiS:</p>
        <ul>
            <li>
                <a href="https://www.schulentwicklung.nrw.de/e/lernstand8/hintergrundinformationen/testkonzeption/kompetenzstufen/index.html" target="kompetenzstufenbeschreibung">
                    <svg role="graphics-symbol">
                        <use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#box-arrow-up-right"/>
                    </svg>
                    Ausführliche Kompetenzstufenbeschreibungen für alle Fächer
                </a>
            </li>            
        </ul>
        `;
        }

        document.querySelector(`div.rueckmeldung-ks-schuelerebene > div:nth-of-type(1)`).innerHTML += `
        <div class="header">
        <div class="schuelerinfos">Schüler</div>
            ${this.faecherArr
            .map((fach) => {
                if (fach === 'ma')
                    return `<div class="kompetenzstufe ${fach}">${Utilities.printFachLang(fach)}</div>`;
                else {
                    return this.domaenenInGruppe
                        .filter(domaene => domaene.fach === fach)
                        .map(domaene => {
                            return `<div class="kompetenzstufe ${fach} ${domaene.domaene}">${Utilities.printFachLang(fach)}<br/>${domaene.bezeichnung}</div>`
                        }).join('');
                }
            }).join('')}
        </div>
        `;

        await this.initSortierungSpaltenkoepfe();

        // initiale Sortierung anzeigen
        document.addEventListener('refresh-rueckmeldung', () => {
            this.refreshKsSchuelerebene();
        });
        document.dispatchEvent(new Event('refresh-rueckmeldung'));

        return true;
    }

    override async onSeiteFinished(): Promise<boolean> {
        return true;
    }

    override async onSeiteLeave(): Promise<boolean> {
        return true;
    }

    private refreshKsSchuelerebene(): void {
        let testsInGruppe = Utilities.cloneObject(this.testsInGruppe) as ISchueler_testsAPI[];

        //region Einträge nach ausgewählter Spalte sortieren
        let kategorie: string = document.querySelector(`[data-sort-kategorie][data-sort-richtung]`)?.getAttribute('data-sort-kategorie') ?? null;
        let richtung: string = document.querySelector(`[data-sort-kategorie][data-sort-richtung]`)?.getAttribute('data-sort-richtung') ?? null;

        if (kategorie === null || kategorie === 'schuelerinfo') {
            testsInGruppe.sort((a, b) => {
                return (
                    this.schuelerliste.filter((s) => s.schueler_id === a.schueler_id)[0].nr
                    <
                    this.schuelerliste.filter((s) => s.schueler_id === b.schueler_id)[0].nr
                ) ? -1 : 1;
            });
        }

        for (const column of this.faecherArr) {
            if (kategorie !== column)
                continue;

            // Kompetenzstufe absteigend sortieren
            testsInGruppe
                .sort((a, b) => {
                    //TODO:medium nicht nach LH sondern nach KS sortieren
                    if (a.loesungshaeufigkeiten === null && b.loesungshaeufigkeiten === null) return 0;
                    if (a.loesungshaeufigkeiten === null) return -1;
                    if (b.loesungshaeufigkeiten === null) return 1;

                    if (a.nicht_anwesend === 1 && b.nicht_anwesend === 1) return 0;
                    if (a.nicht_anwesend === 1) return -1;
                    if (b.nicht_anwesend === 1) return 1;

                    let lhA = a.loesungshaeufigkeiten.domaenen.filter(d => d.name === column)[0].werte ?? null;
                    let lhB = b.loesungshaeufigkeiten.domaenen.filter(d => d.name === column)[0].werte ?? null;

                    if (
                        (lhA.rProz * 100000 + lhA.nProz * 1000 + lhA.fProz) >
                        (lhB.rProz * 100000 + lhB.nProz * 1000 + lhB.fProz)
                    )
                        return 1;

                    if (
                        (lhA.rProz * 100000 + lhA.nProz * 1000 + lhA.fProz) <
                        (lhB.rProz * 100000 + lhB.nProz * 1000 + lhB.fProz)
                    )
                        return -1;

                    return 0;
                });
        }

        // Sortierung umkehren
        if (richtung === 'desc') {
            testsInGruppe.reverse();
        }
        //endregion

        //region Hinweistext einblenden, wenn niemand das Fach testet
        if (testsInGruppe.length === 0) {
            if (this.sessionvariablen.get['fach'] && this.sessionvariablen.get['gruppeid']) {
                document.querySelector(`div.rueckmeldung-ks-schuelerebene`).innerHTML =
                    `Keine Schüler
                        ${((this.gruppeAngezeigt.typ === 'STAMMKLASSE') ? 'der Stammklasse' : 'des Kurses') ?? 'der Gruppe'} <i>${this.gruppeAngezeigt.bezeichnung ?? ''}</i>
                        haben Ergebnisse im Fach ${Utilities.printFachLang(this.sessionvariablen.get['fach'])} eingetragen.
                        `;
            } else {
                document.querySelector(`div.rueckmeldung-ks-schuelerebene`).innerHTML = `Wählen Sie ein Fach und eine Gruppe aus, für die Sie Rückmeldungen einsehen möchten.`;
            }
            return;
        }
        //endregion

        //region Tabelle in DOM rendern
        document.querySelector(`div.rueckmeldung-ks-schuelerebene > div:nth-of-type(2)`)
            .innerHTML = this.schuelerInGruppe.map(schueler => {

            return `
            <div class="schueler" data-nr="${schueler.nr}" data-schuelerid="${schueler.schueler_id}">
                <div class="schuelerinfos">
                    <div class="eigenschaften">
                        <span class="schuelerbezeichnung">Schüler${(schueler.geschlecht === 1) ? `` : (schueler.geschlecht === 2) ? `in` : `:in`}</span> <span class="nummer">${schueler.nr.toString().padStart(3, '0')}</span>
                        ${(schueler.geschlecht !== null) ? `
                        <span class="geschlecht">
                            <svg role="graphics-symbol">
                                <use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#gender-${(schueler.geschlecht === 1) ? 'male' : (schueler.geschlecht === 2) ? 'female' : (schueler.geschlecht === 3) ? 'ambiguous' : 'null'}"/>
                            </svg>
                        </span>
                        ` : ``}
                        <span class="zusatzflags">
                            ${(schueler.is_f === 1) ? `<span data-tooltip="${TOOLTIP_INHALTE.sonderpaedagogischerFoerderbedarf}">F</span>` : ``}
                            ${(schueler.is_s === 1) ? `<span data-tooltip="${TOOLTIP_INHALTE.unzureichendeSprachbeherrschung}">S</span>` : ``}
                        </span>
                    </div>
                    <div class="klarname">
                        <span data-tresor-anzeige="schueler" data-nr="${schueler.nr}"></span>
                    </div>
                </div>

            ${this.faecherArr
                .map(fach => {
                    let test = this.testliste.filter(t => t.schueler_id === schueler.schueler_id && t.fach === fach)[0] ?? null;
                    if (test === null)
                        return `<div class="kompetenzstufe">-</div>`;

                    if (fach === 'ma') {
                        if (test.nicht_anwesend === 1 || test.loesungshaeufigkeiten === null)
                            return `<div class="kompetenzstufe" data-tooltip="${Tooltip.html`
                                <p><strong>Nicht teilgenommen</strong></p>
                                <p>Die Schüler:in hat an diesem Test nicht teilgenommen.</p>
                            `}">-</div>`;

                        let stufe = this.stufengrenzenliste
                            .filter(stufe =>
                                stufe.fach === fach &&
                                stufe.kategorie === `${(this.sessionvariablen.schule.land === 'hb' && ['en', 'fr'].includes(fach)) ? 'ms' : 'ks'}` &&
                                stufe.testheft_id === test.testheft_id &&
                                (test.loesungshaeufigkeiten.insgesamt.r >= stufe.min_richtig && test.loesungshaeufigkeiten.insgesamt.r <= stufe.max_richtig)
                            )[0] ?? null;
                        if (stufe === null)
                            return `<div class="kompetenzstufe">-</div>`;
                        if (stufe.bezeichnung_kurz === null)
                            return `<div class="kompetenzstufe">-</div>`;

                        return `
                        <div class="kompetenzstufe">
                            <span class="label-kompetenzstufe"
                                data-kategorie="${stufe.kategorie}"
                                data-land="${stufe.land}"
                                data-fach="${stufe.fach}"
                                data-testheftid="${stufe.testheft_id}"
                                data-domaene="${stufe.domaene}"
                                data-nr="${stufe.nr}"
                                data-tooltip="${Tooltip.html`
                                    <p><strong>${stufe.bezeichnung_kurz ?? 'Kompetenzstufe'}</strong></p>
                                    <p>${stufe.bezeichnung ?? ''}</p>
                                `}"
                            >${stufe.bezeichnung_kurz ?? ''}</span>
                            <span class="ks-langform">${stufe.bezeichnung ?? ''}</span>
                        </div>`;
                    } else {
                        return this.domaenenInGruppe
                            .filter(domaene => domaene.fach === fach)
                            .map(domaene => {
                                if (test.nicht_anwesend === 1 || test.loesungshaeufigkeiten === null)
                                    return `<div class="kompetenzstufe" data-tooltip="${Tooltip.html`
                                        <p><strong>Nicht teilgenommen</strong></p>
                                        <p>Die Schüler:in hat an diesem Test nicht teilgenommen.</p>
                                    `}">-</div>`;

                                let stufe = this.stufengrenzenliste.filter(stufe =>
                                    stufe.domaene === domaene.domaene &&
                                    stufe.kategorie === `${(this.sessionvariablen.schule.land === 'hb' && ['en', 'fr'].includes(fach)) ? 'ms' : 'ks'}` &&
                                    stufe.testheft_id === test.testheft_id &&
                                    (
                                        test.loesungshaeufigkeiten.domaenen.filter(d => d.name === domaene.domaene)[0].werte.r >= stufe.min_richtig &&
                                        test.loesungshaeufigkeiten.domaenen.filter(d => d.name === domaene.domaene)[0].werte.r <= stufe.max_richtig
                                    )
                                )[0] ?? null;
                                if (stufe === null)
                                    return `<div class="kompetenzstufe">-</div>`;
                                if (stufe.bezeichnung_kurz === null)
                                    return `<div class="kompetenzstufe">-</div>`;

                                return `
                                <div class="kompetenzstufe">
                                    <span class="label-kompetenzstufe"
                                        data-kategorie="${stufe.kategorie}"
                                        data-land="${stufe.land}"
                                        data-fach="${stufe.fach}"
                                        data-testheftid="${stufe.testheft_id}"
                                        data-domaene="${stufe.domaene}"
                                        data-nr="${stufe.nr}"
                                        data-tooltip="${Tooltip.html`
                                            <p><strong>${stufe.bezeichnung_kurz ?? 'Kompetenzstufe'}</strong></p>
                                            <p>${stufe.bezeichnung ?? ''}</p>
                                        `}"
                                    >${stufe.bezeichnung_kurz ?? ''}</span>
                                    <span class="ks-langform">${stufe.bezeichnung ?? ''}</span>
                                </div>`;
                            }).join('');
                    }
                })
                .join('')}     
            </div>`
        }).join('');
        //endregion

        if (this.tresor?.offen === true)
            this.tresor.fillTresorLuecken();
    }

}
